import { useCallback } from 'react';

export const usePutCustomLineItemFormChange = ({
  values: { rate, unit },
  setFieldValue
}) => {
  return {
    onDescriptionChange: useCallback(
      e => {
        setFieldValue('description', e.target.value);
      },
      [setFieldValue]
    ),
    onProjectChange: useCallback(
      (_, value) => {
        setFieldValue('project', value);
      },
      [setFieldValue]
    ),
    onUnitChange: useCallback(
      ({ target: { value } }) => {
        setFieldValue('unit', value ?? 0);

        setFieldValue('amount', rate * (value ?? 0));
      },
      [rate, setFieldValue]
    ),
    onLabelChange: useCallback(
      e => {
        setFieldValue('label', e.target.value);
      },
      [setFieldValue]
    ),
    onAmountChange: useCallback(
      e => {
        setFieldValue('amount', e.target.value);
      },
      [setFieldValue]
    ),
    onRateChange: useCallback(
      ({ target: { value } }) => {
        setFieldValue('rate', value ?? 0);

        setFieldValue('amount', (unit ?? 0) * (value ?? 0));
      },
      [setFieldValue, unit]
    )
  };
};

export default usePutCustomLineItemFormChange;
